<template>
  <div class="app-main__inner">
    <TituloComponent icono-titulo="fas fa-pencil-alt" texto-titulo="Editar Sindicato"></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarSindicato()">
          <float-label label="Código:" clase>
            <input
              v-model="sindicato.codigo"
              id="codigo"
              placeholder="Ingresar un código..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.sindicato.codigo.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.sindicato.codigo.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="sindicato.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="(enviado && !$v.sindicato.descripcion.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.sindicato.descripcion.required"
              >Debe ingresar una descripción</div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from 'vuelidate/lib/validators';
import axios from "axios";
import Swal from "sweetalert2";
import Sindicato from "@/models/sindicato";
export default {
  name: "EditarSindicato",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      sindicato: new Sindicato(null, "", ""),
      loading: false,
      enviado:false
    };
  },  
  validations:{
    sindicato:{
      codigo:{required},
      descripcion:{required},
    }
  },
  mounted() {
    this.sindicato.id = this.$route.params.id;
    this.getSindicato();
  },
  methods: {
    getSindicato() {
      this.loading = true;
      axios
        .get("sindicatos/" + this.sindicato.id)
        .then(res => {
          console.log(res.data);
          if (res.data.success) {
            this.sindicato = res.data.sindicato;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado sindicatos.`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarSindicato() {
      this.enviado = true
      this.loading = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      axios
        .put("/sindicatos/" + this.sindicato.id, this.sindicato)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.sindicato.descripcion} se editó con éxito.`
            });
            this.$router.push({ name: "ListarSindicatos" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>